import type { Discount } from '@carvana/merch-contracts';
import DiscountType from '@carvana/merch-contracts/DiscountType';
import { useMemo } from 'react';
import { useVehiclePaymentTerms } from '~/context/vdp/UserVehicleContext';

export default function useGetRootDiscount(): Discount | null {
  const { discounts = [] } = useVehiclePaymentTerms();

  return useMemo<Discount | null>(
    () =>
      discounts.find(
        discount => discount.type === DiscountType.RootTotalLoss
      ) ?? null,
    [discounts]
  );
}
